<template>
<div class="chapter">
<div class="inner_page">
<p class="ornament-prect"><img alt="image" src="images/ornament.jpg"/></p>
<p class="prect"><a id="pVI"></a><a id="pVII"></a>CONTENTS</p>
<p class="contents-prect"><a href="#/list_of_illustrations.htm#illus"><i>List of Illustrations</i></a></p>
<p class="contents-prect"><a href="#/list_of_principal_characters.htm#char"><i>List of Principal Characters</i></a></p>
<p class="contents-prect"><a href="#/preface.htm#preface"><i>Preface</i></a></p>
<p class="contents-ct1"><a href="#/chapter_1.htm#ct1"><span class="conblock">  1 </span>From Archduchess to Dauphine</a></p>
<p class="contents-ct"><a href="#/chapter_2.htm#ct2"><span class="conblock">  2 </span>The Court under Louis XVI and Marie-Antoinette</a></p>
<p class="contents-ct"><a href="#/chapter_3.htm#ct3"><span class="conblock">  3 </span>A Queen in Search of a Role, 1774–1781</a></p>
<p class="contents-ct"><a href="#/chapter_4.htm#ct4"><span class="conblock">  4 </span>Growing Unpopularity, 1781–1785</a></p>
<p class="contents-ct"><a href="#/chapter_5.htm#ct5"><span class="conblock">  5 </span>The Diamond Necklace Affair, 1785–1786</a></p>
<p class="contents-ct"><a href="#/chapter_6.htm#ct6"><span class="conblock">  6 </span>The Ascendancy of Marie-Antoinette, 1787–1788</a></p>
<p class="contents-ct"><a href="#/chapter_7.htm#ct7"><span class="conblock">  7 </span>The Last Year at Versailles</a></p>
<p class="contents-ct"><a href="#/chapter_8.htm#ct8"><span class="conblock">  8 </span>Appeasement and Plans for Resistance: The Tuileries and Saint-Cloud</a></p>
<p class="contents-ct"><a href="#/chapter_9.htm#ct9"><span class="conblock">  9 </span>The Flight to Varennes</a></p>
<p class="contents-ct"><a href="#/chapter_10.htm#ct10"><span class="conblock">10 </span> Marie-Antoinette will become Queen of France again’: Government by Letter</a></p>
<p class="contents-ct"><a href="#/chapter_11.htm#ct11"><span class="conblock">11 </span>The Fall of the Monarchy</a></p>
<p class="contents-ct"><a href="#/chapter_12.htm#ct12"><span class="conblock">12 </span>Imprisonment in a Tower</a></p>
<p class="contents-prect"><a href="#/conclusion.htm#conclusion">Conclusion</a></p>
<p class="contents-prect"><a href="#/epilogue_ubi_sunt.htm#epilogue">Epilogue: <i>Ubi sunt?</i></a></p>
<p class="contents-prect--"><a href="#/notes.htm#notes"><i>Notes</i></a></p>
<p class="contents-prect"><a href="#/a_bibliographical_essay.htm#essay"><i>A Bibliographical Essay</i></a></p>
<p class="contents-prect"><a href="#/bibliography.htm#biblio"><i>Bibliography</i></a></p>
<p class="contents-prect"><a href="#/index.htm#index"><i>Index</i></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?1b5dd4d1